import { E164_PHONE_NUMBER_REGEXP, US_PHONE_NUMBER_REGEXP } from './regexp';
import { formatE164ToUSPhoneNumber, formatUSPhoneNumberToE164 } from './format';

export default {
  E164_PHONE_NUMBER_REGEXP,
  US_PHONE_NUMBER_REGEXP,
  formatE164ToUSPhoneNumber,
  formatUSPhoneNumberToE164,
};
